import React from 'react'
import { useTranslation } from 'react-i18next'
import SubmitButton from "components/SubmitButton"

const ConfirmModal = ({ closeModal, confirmAction, title, message, style, confirmText, cancelText, isLoading, loadingText }) => {
  const { t } = useTranslation()
  return (
    <div className="modal-content" style={style}>
      <div className="modal-header">
        <h5
          className="modal-title"
        >{title}</h5>
        <button type="button" className="btn-close" aria-label={t('common.close')} onClick={closeModal}></button>
      </div>
      <div className="modal-body">
        <p>{message}</p>
      </div>
      <div className="modal-footer">
        <button type="button" onClick={closeModal} className="btn btn-outline-primary">{cancelText || t('common.cancel')}</button>
        <SubmitButton type="button" onClick={confirmAction} isLoading={isLoading} text={confirmText || t('common.confirm')} loadingText={loadingText || t('common.saving')} />
      </div>
    </div>
  )
}

export default ConfirmModal
